import { inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
} from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from './custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  
  private readonly snackBar= inject(MatSnackBar);

  showSuccess(
    message: string,
    position: MatSnackBarHorizontalPosition = 'center',
    top?: string
  ) {
    const config = this.getSnackBarConfig(position, 'success-snackbar');
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      ...config,
      data: { message, type: 'success', top },
    });
  }

  showError(
    message: string | { description: string }[],
    position: MatSnackBarHorizontalPosition = 'center',
    top?: string
  ) {
    const config = this.getSnackBarConfig(position, 'error-snackbar');
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      ...config,
      data: { message, type: 'error', top },
    });
  }

  private getSnackBarConfig(
    position: MatSnackBarHorizontalPosition,
    panelClass: string
  ): MatSnackBarConfig {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = position;
    config.verticalPosition = 'top';
    config.duration = 5000;
    config.panelClass = [panelClass];
    return config;
  }
}
